export default {
    methods: {
        getUserSearchSession() {
            if (typeof window.search_list === 'undefined') {
                return [];
            }

            return JSON.parse(window.search_list);
        },
        getUserSearchSessionByType(type) {
            return this.getUserSearchSession().filter(search => search.type === type);
        },
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/search.js